import * as React from 'react';
import { Outside } from '@cian/ui-kit';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';
import { IBaseSelectValue } from '../../../types/select';
import * as styles from './styles.css';

interface IPopoverDropdownProps {
  values: IBaseSelectValue[];
  value: number;
  onClose(): void;
  onValueChange(value: number): void;
}

export function PopoverDropdown({ value, values, onValueChange, onClose }: IPopoverDropdownProps) {
  const onItemClick = React.useCallback((id: number) => () => onValueChange(id), [onValueChange]);

  return (
    <Outside onOutside={onClose}>
      <ul className={styles['container']}>
        {values.map(({ id, text }) => {
          const isActive = id === value;

          return (
            <li
              key={id}
              className={classNames(styles['item'], isActive && styles['item--selected'])}
              onClick={onItemClick(id)}
            >
              <span className={styles['text']}>{text}</span>
              {isActive && (
                <span className={styles['selected_icon']}>
                  <IconFunctionalSuccess16 color="icon-main-default" />
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </Outside>
  );
}
